<fin-smp
  [availability$]="serviceAvailability$"
  [cartDataReady$]="dataReady$"
  [hasTravelerInCart$]="hasTravelerInCart$"
  [priceUpdating$]="priceUpdating$"
  [flights$]="allFlights$"
  [bounds$]="bounds$"
  [travelers$]="passengers$"
  [servicesMap$]="servicesMap$"
  [locations$]="locations$"
  [cartTotalPrice$]="cartTotalPrice$"
  [servicesReady$]="servicesReady$"
  [passengersWithPetcIncompatibleSeats$]="passengersWithPetcIncompatibleSeats$"
  (message)="message.next($event)"
  (continueToNextPhase)="ready.emit(true)"
></fin-smp>
